<script>
  import { Promised } from 'vue-promised';
  import Loader from '@/_legacy/components/Icons/Loader.vue';

  export default {
    name: 'Promised',
    components: {
      PromisedContainer: Promised,
      Loader,
    },
    props: {
      asyncData: {
        required: false,
        validator: p => p
          && typeof p.then === 'function'
          && typeof p.catch === 'function',
      },
    },
    computed: {
      hasRejectSlot() {
        return !!this.$slots.rejected;
      },
    },
  };
</script>

<template>
  <div v-if="!asyncData">
    <slot></slot>
  </div>
  <PromisedContainer v-else pending-delay="0" :promise="asyncData">
    <template #pending>
      <slot name="pending">
        <Loader />
      </slot>
    </template>

    <slot>
      <div class="hidden">No default value provided</div>
    </slot>

    <template v-if="hasRejectSlot" #rejected>
      <slot name="rejected"></slot>
    </template>
  </PromisedContainer>
</template>
